/** 入会申请表单编码（与小程序 /api/mp/form 一致） */
export const MEMBERSHIP_APPLY_FORM_CODE = 'membership_apply'

export function parseFormFieldOptionsJson(raw) {
  const s = String(raw || '').trim()
  if (!s) return []
  try {
    const arr = JSON.parse(s)
    if (!Array.isArray(arr)) return []
    return arr
      .map((it) => {
        if (it && typeof it === 'object') {
          const label = String(it.label ?? '').trim()
          const value = String(it.value != null ? it.value : '').trim()
          const v = value || label
          const l = label || value
          if (!v) return null
          return { value: v, label: l || v }
        }
        const text = String(it || '').trim()
        return text ? { value: text, label: text } : null
      })
      .filter(Boolean)
  } catch {
    return []
  }
}

/**
 * @param {() => Promise<Array>} getForms
 * @param {(formId: number|string) => Promise<Array>} getFormFields
 * @returns {Promise<{ base: Array<{value:string,label:string}>, error: string }>}
 */
export async function loadApplyDutyOptionsFromMembershipForm(getForms, getFormFields) {
  try {
    const forms = (await getForms()) || []
    const form = forms.find((f) => String(f?.code || '').trim() === MEMBERSHIP_APPLY_FORM_CODE)
    if (!form || form.id == null) {
      return { base: [], error: '未找到入会表单 membership_apply，请在表单管理中创建' }
    }
    const fields = (await getFormFields(form.id)) || []
    const dutyField =
      fields.find((x) => String(x.fieldKey || '').trim() === 'applyDuty') ||
      fields.find((x) => String(x.label || '').includes('申请职务'))
    if (!dutyField) {
      return { base: [], error: '入会表单中未找到「申请职务」字段（fieldKey=applyDuty）' }
    }
    const ft = String(dutyField.fieldType || '').toUpperCase()
    if (!['SELECT', 'RADIO'].includes(ft)) {
      return {
        base: [],
        error: `「申请职务」控件类型为 ${dutyField.fieldType || '-'}，请改为下拉或单选并维护选项`,
      }
    }
    const base = parseFormFieldOptionsJson(dutyField.optionsJson)
    if (!base.length) {
      return { base: [], error: '「申请职务」暂无选项，请在表单管理中为该字段填写选项' }
    }
    return { base, error: '' }
  } catch (e) {
    return { base: [], error: e?.message || '读取入会表单字段失败' }
  }
}
